import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import DashboardContainer from '../../../../presentation/DashboardContainer';
import layout from './layout.json';
import moment from 'moment';

export default class DashboardList extends React.Component {
  constructor( props ) {
    super( props );
    this.onRenderData = this.onRenderData.bind( this );
    this.onRenderServerRoutingData = this.onRenderServerRoutingData.bind( this );
    this.onRenderQuickCallStatsData = this.onRenderQuickCallStatsData.bind( this );
    this.onRenderOptInValuesData = this.onRenderOptInValuesData.bind( this );
    this.onRenderRiskNoRiskData = this.onRenderRiskNoRiskData.bind( this );
    this.onRenderProgramsData = this.onRenderProgramsData.bind( this );
    this.onGridFormatItem = this.onGridFormatItem.bind( this );
    this.onGridFormatItemPrograms = this.onGridFormatItemPrograms.bind( this );
  }

  getServerState( state ) {
    switch( state ) {
    case 0:
      return 'Not Serving';
    case 1:
      return 'Serving';
    case 2:
      return 'Serving Default Program';
    default:
      return 'Not Serving';
    }
  }

  getPrimaryServer( server, primary ) {
    if( server.ServerName.toLowerCase() === primary.PRIMARY_SERVER.toLowerCase() ) {
      return 'Yes';
    }
    return 'No';
  }

  onRenderServerRoutingData( data ) {
    if( data !== undefined ) {
      if( data.length > 0 ) {
        let result = [];
        const servers = data[0]; // Get the servers records
        const primary = data[1][0]; // Get the primary server record
        for( let serverIndex = 0; serverIndex < servers.length; serverIndex++ ) {
          const server = servers[ serverIndex ];
          let serverState = this.getServerState( server.SERVER_STATE );
          let isPrimary = this.getPrimaryServer( server, primary );
          result.push( {
            'NAME': server.ServerName,
            'STATE': serverState,
            'PRIMARY': isPrimary
          } );            
        }
        return result;
      }
    }
    return [];
  }

  onRenderQuickCallStatsData( data ) {

    data.map( ( item ) => { 
      
      // Create percent from Percentage of Average decimal
      const percentageOfAvg = parseFloat( item[ '% OF AVG' ] );
      const percenteOfAvg = ( percentageOfAvg.toFixed( 4 ) * 100 );
      item[ '% OF AVG' ] = percenteOfAvg.toFixed( 0 ).toString() + ' %';

      // Create percent from Percentage of Served decimal
      const percentageServed = parseFloat( item[ '% SERVED' ] );
      const percentServed = ( percentageServed.toFixed( 4 ) * 100 );
      item[ '% SERVED' ] = percentServed.toFixed( 0 ).toString() + ' %';

      // Format the date/time for Stats Since
      let datetime = moment( item[ 'STATS SINCE' ] );
      item[ 'STATS SINCE' ] = datetime.format( 'YYYY-MM-DD HH:mm:ss' );

      return item;
    } );
    return data;
  }

  onRenderOptInValuesData( data ) {
    return data;
  }

  onRenderRiskNoRiskData( data ) {

    data.map( ( item ) => {

      // Create percent from Percentage of Good decimal
      const percentageGood = parseFloat( item[ '% GOOD' ] );
      const percentGood = ( percentageGood.toFixed( 4 ) * 100 );
      item[ '% GOOD' ] = percentGood.toFixed( 0 ).toString() + '%';

      // Create percent from Percentage of Risk decimal
      const percentageRisk = parseFloat( item[ '% RISK' ] );
      const percentRisk = ( percentageRisk.toFixed( 4 ) * 100 );
      item[ '% RISK' ] = percentRisk.toFixed( 0 ).toString() + '%';
    
      return item;
    } );
    return data;
  }

  onRenderProgramsData( data ) {
    data.map( ( item ) => {
      const overagePercentage = parseFloat( item[ 'OVERAGE_PCNT' ] );
      const overagePercent = overagePercentage.toFixed( 4 ) * 100;
      item[ 'OVERAGE_PCNT' ] = overagePercent.toFixed( 0 ).toString() + ' %';

      const optInPercentage = parseFloat( item[ 'OPT_RATE' ] );
      const optInPercent = optInPercentage.toFixed( 3 ) * 100;
      item['OPTIN_PCNT'] = optInPercent.toFixed( 1 ).toString() + ' %';

      const attPercentage = parseFloat( item[ 'ATT_RATE' ] );
      const attInPercent = attPercentage.toFixed( 3 ) * 100;
      item['ATT_PCNT'] = item['ATTEMPTING'] + '/' + attInPercent.toFixed( 1 ).toString() + ' %';

      const connPercentage = parseFloat( item[ 'CON_RATE' ] );
      const connInPercent = connPercentage.toFixed( 3 ) * 100;
      item['CONN_PCNT'] = connInPercent.toFixed( 1 ).toString() + ' %';

      const predFillPercentage = parseFloat( item[ 'FILLED' ] );
      const predFillInPercent = predFillPercentage.toFixed( 3 ) * 100;
      item['PRED_FILL_PCNT'] = predFillInPercent.toFixed( 1 ).toString() + ' %';

      const seatsOvgRatePercentage = parseFloat( item[ 'SEATS_OVG_RATE' ] );
      const seatsOvgRatePercent = seatsOvgRatePercentage.toFixed( 3 ) * 100;

      item['ACT_FILLED'] = parseInt( item[ 'SEATS_FILLED' ], 10 ).toString() + '/' + item[ 'SEATS_OVG' ] + ' - ' + seatsOvgRatePercent.toFixed( 0 ).toString() + ' %';

      return data;
    } );
    return data;
  }

  onRenderCouponSummary( data ) {
    data.map( ( item ) => {

      const optInPercentage = parseFloat( item[ 'OPTIN_PCNT' ] );
      const optInPercent = optInPercentage.toFixed( 3 ) * 100;
      item['OPTIN_PCNT'] = optInPercent.toFixed( 1 ).toString() + ' %';

      const attemptPercentage = parseFloat( item[ 'ATTEMPT_PCNT' ] );
      const attemptInPercent = attemptPercentage.toFixed( 3 ) * 100;
      item['ATTEMPT_PCNT'] = attemptInPercent.toFixed( 1 ).toString() + ' %';

      const connPercentage = parseFloat( item[ 'CONNECT_PCNT' ] );
      const connInPercent = connPercentage.toFixed( 3 ) * 100;
      item['CONNECT_PCNT'] = connInPercent.toFixed( 1 ).toString() + ' %';

      return data;
    } );
    return data;
  }
  
  onRenderData( key, data ) {
    if( key === 'Server Routing' ) {
      return this.onRenderServerRoutingData( data );
    } else if( key === 'Quick Call Stats' ) {
      return this.onRenderQuickCallStatsData( data[ 0 ] );
    } else if( key === 'Opt-In Values' ) { 
      return this.onRenderOptInValuesData( data[ 0 ] );
    } else if( key === 'Risk - No Risk' ) {
      return this.onRenderRiskNoRiskData( data[ 0 ] );
    } else if( key === 'Programs' ) {
      return this.onRenderProgramsData( data[ 0 ] );
    } else if( key === 'Coupon Summary' ) {
      return this.onRenderCouponSummary( data[ 0 ] );
    }
    return [];
  }

  onGridFormatItem( key, panel, e ) {
    if( key === 'Programs' ) {
      this.onGridFormatItemPrograms( panel, e );
    }
  }

  onGridFormatItemPrograms( panel, e ) {
    let row_itr = 0;
    let hostElement = panel.cells.hostElement;
    if( hostElement !== undefined ) {
      for( let i = 0; i < hostElement.childElementCount - 1; i++ ) {
        let row = hostElement.children[i + 1];
        
        if( panel.itemsSource !== undefined ) {
          if( panel.itemsSource[i] === undefined ){
            continue;
          }
        }
        let isMultiAdRow = panel.itemsSource[i].IS_MULTIAD_TOTAL_ROW;
        if( isMultiAdRow === undefined ) {
          isMultiAdRow = 0;
        }

        if( isMultiAdRow === 1 ) {
          panel.rows[i].height = 40;
          for( let row_itr = 0; row_itr < row.childElementCount; row_itr++ ){
            let cell = row.children[row_itr];
            let cellStyle = cell.style;
            cellStyle.backgroundColor = 'cornsilk';
            cellStyle.fontWeight = 'bold';
            cellStyle.borderTop = 'solid 3pt black';
            cellStyle.borderBottom = 'solid 1pt black';
            cellStyle.height = '40px';
            cellStyle.lineHeight='30px';
            cell.innerHTML = '<strong style="color: black;">' + cell.innerText + '</strong>';
          }

        } else {
          
          //This can probably start later because of which cells are colored
          for( row_itr = 0; row_itr < row.childElementCount; row_itr++ ) {
            let cell = row.children[row_itr];
            let cellStyle = cell.style;
            cellStyle.backgroundColor = '';
            cellStyle.fontWeight = '';
            cellStyle.borderTop = '';
            cellStyle.borderBottom = '';
            panel.rows[i].height = 30;
            cellStyle.height = '30px';
            cellStyle.lineHeight='20px';
            //cell.innerHTML = cell.innerText;

            // Check OPT-IN PERCENTAGE 
            if( row_itr === 12 ){
              if( panel.itemsSource[i].OPT_PROG === 'RED' ) {
                cellStyle.backgroundColor = 'red';
                cellStyle.color = 'white';
              } else if( panel.itemsSource[i].OPT_PROG === 'BLUE' ) {
                cellStyle.backgroundColor = 'blue';
                cellStyle.color = 'white';
              } else if( panel.itemsSource[i].OPT_PROG === 'YELLOW' ) {
                cellStyle.backgroundColor = 'yellow';
                cellStyle.color = '#000000';
              } else if( panel.itemsSource[i].OPT_PROG === 'CYAN' ) {
                cellStyle.backgroundColor = 'cyan';
                cellStyle.color = '#000000';
              }
            }

            // Check CONNECTION PERCENTAGE 
            if( row_itr === 14 ) {
              if( panel.itemsSource[i].CONN_PROG === 'RED' ) {
                cellStyle.backgroundColor = 'red';
                cellStyle.color = 'white';
              } else if( panel.itemsSource[i].CONN_PROG === 'BLUE' ) {
                cellStyle.backgroundColor = 'blue';
                cellStyle.color = 'white';
              } else if( panel.itemsSource[i].CONN_PROG === 'YELLOW' ) {
                cellStyle.backgroundColor = 'yellow';
                cellStyle.color = '#000000';
              } else if( panel.itemsSource[i].CONN_PROG === 'CYAN' ) {
                cellStyle.backgroundColor = 'cyan';
                cellStyle.color = '#000000';
              }
            }

            // Check PREDICTED FILL PERCENTAGE 
            if( row_itr === 16 ) {
              if( panel.itemsSource[i].FILL_PROG === 'RED' ) {
                cellStyle.backgroundColor = 'red';
                cellStyle.color = 'white';
              } else if( panel.itemsSource[i].FILL_PROG === 'BLUE' ) {
                cellStyle.backgroundColor = 'blue';
                cellStyle.color = 'white';
              } else if( panel.itemsSource[i].FILL_PROG === 'YELLOW' ) {
                cellStyle.backgroundColor = 'yellow';
                cellStyle.color = '#000000';
              } else if( panel.itemsSource[i].FILL_PROG === 'CYAN' ) {
                cellStyle.backgroundColor = 'cyan';
                cellStyle.color = '#000000';
              }
            }
          }
        }
      }
    }
  }
  
  render( ) {
    return (
      <PageAuthorize groups={['Administrators','Operations','Management','Dashboards']} >
        <DashboardContainer layout={layout} onRenderData={this.onRenderData} onGridFormatItem={this.onGridFormatItem} />
      </PageAuthorize>
    );
  }
}



// WEBPACK FOOTER //
// ./src/content/dashboards/programs/components/ProgramsDashboardList.js